import { ReactNode, useState } from "react";
import styled from "styled-components";

interface Props {
  title: string;
  version: string;
  open: boolean;
  children: ReactNode;
  icon: any;
}

export default function AccordionCart({
  title,
  open,
  children,
  icon,
  version,
}: Props) {
  const [showInfo, setShowInfo] = useState(open);
  return (
    <Wrapper>
      <article
        className={`accordion-cart ${version} ${showInfo ? "active" : ""}`}
      >
        <header onClick={() => setShowInfo(!showInfo)}>
          <div className="header-wrapper">
            <h4>
              {icon} {title}
            </h4>
          </div>
          <button className={`btn ${showInfo ? "" : "active"}`}>
            <svg
              width={14}
              height={8}
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 7L7 1L1 7"
                stroke="#989EAF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </header>
        {showInfo && <div className="acc-cont">{children}</div>}
      </article>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .accordion-cart {
    width: 100%;
    border-top: 1px solid rgba($color: #0c0d1e, $alpha: 0.1);
    border-bottom: 1px solid rgba($color: #0c0d1e, $alpha: 0.1);
    cursor: pointer;
  }

  .accordion-cart h4 {
    font-style: normal;
    font-weight: 300;
    font-size: 1.6rem;
    line-height: 125%;
    color: #444444;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // transition: all .3s;

    svg {
      margin-right: 12px;

      path {
        stroke: #444444;
      }
    }

    @media only screen and (max-width: 600px) {
      font-size: 1.75rem;
    }
  }

  .accordion-cart .acc-cont {
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 170%;
    color: rgba($color: #3a4155, $alpha: 0.75);
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    padding-bottom: 2.4rem;
    padding-top: 0;
    margin-bottom: 6px;

    @media only screen and (max-width: 600px) {
      font-size: 1.5rem;
    }

    &::-webkit-scrollbar {
      width: 2.4rem;
    }

    &::-webkit-scrollbar-track {
      margin-bottom: 2.4rem;
      border-radius: 0.2rem;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba($color: #0c0d1e, $alpha: 0.1);
      border-radius: 1.6rem;
      border: 10px solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-track-piece {
      background: rgba($color: #0c0d1e, $alpha: 0.1);
      background: transparent;
    }

    .popup-buy-as-guest {
      .container {
        .header {
          display: none;
        }

        .body {
          padding: 0;
          margin-top: 0;

          .fast-buy-inputs {
            margin: 0;
          }
        }

        .footer-popup {
          position: relative;
          padding: 0;
        }
      }
    }
  }

  .accordion-cart header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5.5rem;
    background-color: transparent;
    padding: 0 1.2rem;

    .header-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .accordion-cart header h4 {
    margin-bottom: 0;
  }

  .btn {
    border-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    align-self: center;
    transition: all 0.3s;
    outline: none;
    width: auto;
    height: auto;

    @media only screen and (max-width: 600px) {
      width: 2rem;
      height: 2rem;
    }

    svg {
      width: 12px;
      height: 6px;
      object-fit: cover;

      @media only screen and (max-width: 600px) {
        width: 12px;
        height: 6px;
      }
    }
  }

  .accordion-cart.acc-side {
    width: 100%;
    border: none;
    padding: 0;
    border-radius: 0;
    margin-bottom: 0;
    border-radius: 6px;

    &.active {
      background-color: #e7ecf5;

      h4 {
        color: #444444;
        font-weight: normal;

        //transition: all .3s;
        svg {
          path {
            stroke: #6a94ff;
          }
        }
      }
    }

    h4 {
      font-weight: 300;
    }

    p {
      // max-height: 25rem;
      // overflow-y: auto;
    }

    .btn {
      width: auto;
      height: auto;

      &.active {
        transform: rotate(-180deg);
      }
    }

    .checkbox-group {
      padding-bottom: 1.2rem;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
`;
